<template>
  <!-- BEGIN: Content-->
  <div class="app-content content ">
    <div class="content-overlay"></div>
    <div class="header-navbar-shadow"></div>
    <div class="content-wrapper">
      <div class="content-header row">
        <div class="content-header-left col-md-9 col-12 mb-2">
          <Breadcrumb
              name="Privilege"
              bc1="App"
              bc2="Privilege"
              bc3="List"
          ></Breadcrumb>
        </div>

      </div>
      <div class="content-body">
        <div class="card">
          <div class="m-2">
            <div class="row">
              <div class="col-md-7 col-7">
                <div class="d-flex align-items-center justify-content-end">

                </div>
              </div>
              <div class="col-md-5 col-5">
                <div class="d-flex align-items-center justify-content-end">
                  <multiselect
                      v-model="selectedGroup"
                      :options="groupsData"
                      label="name"
                      track-by="id"
                      placeholder="Select Group"
                      variant="primary"
                      class="mr-1"
                  ></multiselect>
                  <button
                      type="button"
                      class="btn btn-primary"
                      @click="$router.push({ name: 'privilege-add' })"
                  >
                    <span class="text-nowrap">Add Record</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
          <CommonTable
              :url="url"
              :tableHeaderValues="tableHeaderValues"
              :actions="actions"
              :deleteActions="deleteActions"
              :mutedData="mutedData"
              :storageKey="storageKey"
              :externalTotalRecord="externalTotalRecord"
              :filteredData="filteredData"

          />
        </div>
      </div>
    </div>
  </div>
  <!-- END: Content-->
</template>

<script>
import {CommandIcon} from "vue-feather-icons";

export default {
  components: {CommandIcon},
  created() {
  },
  mounted() {
    localStorage.setItem("url", "v1/get-privilege");
    this.checkDataInStore('v1/get-privilege')
    if (
        typeof this.$route.params.update == "undefined" &&
        typeof this.$route.params.add == "undefined"
    ) {
      this.$store.dispatch("set", null);
    }
    this.getAllRoles()
  },
  data() {
    return {
      url: "v1/get-privilege",
      filteredData:{},
      storageKey: "privilege",
      selectedGroup: null,
      groupsData: [],
      tableHeaderValues: [
        {
          title: "Transaction Name",
          valueKey: "transaction_type.name",
          html: true,
          alter: function (value) {
            if (!value) {
              return "-";
            } else {
              return `<span style="" class=" font-weight-bolder text">${value}</span>`;
            }
          }
        },
        {
          title: "Payment Method",
          valueKey: "currency_payment_method.payment_method.name",
          alter: function (value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        {
          title: "Currency",
          valueKey: "currency_payment_method.currency.name",
          alter: function (value) {
            if (!value) {
              return "-";
            } else {
              return value;
            }
          }
        },
        // {
        //   title: "Status",
        //   valueKey: "status",
        //   html: true,
        //   alter: function(value, row) {
        //     var html = "";
        //     if (value == 1) {
        //       html = `<span class="badge badge-success badge-sm">Active</span>`;
        //     } else {
        //       html = `<span class="badge badge-danger badge-sm">Inactive</span>`;
        //     }
        //
        //     if (row.is_default == 1) {
        //       html += '<span class="badge badge-secondary ml-1">Default</span>';
        //     }
        //     return html;
        //   }
        // }
      ],
      actions: [
        {
          title: "Update",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "privilegeUpdate"
            };
            this.$store.dispatch("set", data);
            this.$router.push({name: "privilege-update"});
          }
        },
        {
          title: "Groups",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "privilegeGroupUpdate"
            };
            this.$store.dispatch("set", data);
            this.$router.push({name: "privilege-group-add"});
          }
        },
        {
          title: "Charges",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "privilegeRoleUpdate"
            };
            this.$store.dispatch("set", data);
            this.$router.push({name: "privilege-role-add"});
          }
        }
      ],
      deleteActions: [
        {
          title: "Delete",
          class: " ml-1 custom-control-primary",
          cta: (row, index) => {
            let data = {
              index: index,
              row: row,
              key: "currencyDelete"
            };
            this.deleteRecord(data);
          }
        }
      ],
      mutedData: [],
      externalTotalRecord: ""
    };
  },
  methods: {
    deleteRecord(row) {
      this.makeRequest("post", "v1/delete-privilege", {
        // status: row.status == true ? 1 : 0,
        // id: row.id
        status: row.row.status == true ? 1 : 0,
        id: row.row.id
      });
    },
    getAllRoles() {
      let type = [2, 3];
      let requestData = {
        flag: "all",
        type: JSON.stringify(type)
      }
      this.makeRequest('post', 'v1/get-role', requestData, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            this.groupsData = callResponse.response.data.data
          }
        }

      });
    },
    //deleteRecord(data) {
    //  this.makeRequest("post", "v1/delete-privilege", {
    //    status: data.row.status == true ? 1 : 0,
    //    id: data.row.id
    //  }).then(callResponse => {
    //    if (!callResponse.error) {
    //      let code = callResponse.response.data.code;
    //      if (code == 200) {
    //        let storeData = this.$store.getters.getByKey("privilege");
    //        if (storeData != null) {
    //          if (typeof storeData.firstPageData != "undefined") {
    //            if (
    //              typeof storeData.firstPageData.data[data.index] != "undefined"
    //            ) {
    //              if (
    //                storeData.firstPageData.data[data.index].id == data.row.id
    //              ) {
    //                storeData.firstPageData.data[data.index] = data.row;
    //                delete storeData.otherPageData;
    //              }
    //            }
    //          }
    //          if (typeof storeData.otherPageData != "undefined") {
    //            if (
    //              typeof storeData.otherPageData.data[data.index] != "undefined"
    //            ) {
    //              if (
    //                storeData.otherPageData.data[data.index].id == data.row.id
    //              ) {
    //                storeData.otherPageData.data[data.index] = data.row;
    //              }
    //            }
    //          }
    //          storeData.key = "privilege";
    //          this.$store.dispatch("set", storeData);
    //        }
    //      }
    //    }
    //  });
    //}
  },
  watch:{
    selectedGroup(val){
      if(val)
        this.filteredData = {groupId : val.id}
      else{
        this.filteredData = {}
      }
    }
  }
};
</script>
